<template>
  <div id="wrapper">
    <MyNavbarVue />
    <MySideBarCompany />
    <div class="content-page">
      <div class="content">
        <RouterView></RouterView>
      </div>
    </div>
  </div>
</template>

<script>
import MyNavbarVue from "@/layouts/MyNavbar.vue";
import MySideBarCompany from "@/layouts/MySideBarCompany.vue";

export default {
  components: {
    MyNavbarVue,
    MySideBarCompany,
  },
};
</script>